export interface TimelineEvent {
  id: number;
  orden: number;
  titulo: string;
  descripcion: string;
  fecha: string;
}

export const timelineEvents: TimelineEvent[] = [
  {
    id: 1,
    orden: 1,
    titulo: "Partida",
    descripcion: "Lorem ipsum dolor sit, consectetuer adipiscing elit.",
    fecha: "01/01/2024",
  },
  {
    id: 2,
    orden: 2,
    titulo: "Primeras etapas",
    descripcion: "Lorem ipsum dolor sit amet, consectetuer adipiscing.",
    fecha: "01/04/2024",
  },
  {
    id: 3,
    orden: 3,
    titulo: "Desarrollo",
    descripcion: "Lorem ipsum dolor sit, consectetuer adipiscing elit.",
    fecha: "01/08/2024",
  },
  {
    id: 4,
    orden: 4,
    titulo: "Segunda etapa",
    descripcion: "Lorem ipsum dolor sit amet, consectetuer adipiscing.",
    fecha: "01/01/2025",
  },
  {
    id: 5,
    orden: 5,
    titulo: "Tercera etapa",
    descripcion: "Lorem ipsum dolor sit, consectetuer adipiscing elit.",
    fecha: "01/06/2025",
  },
  {
    id: 6,
    orden: 6,
    titulo: "Cuarta etapa",
    descripcion: "Lorem ipsum dolor sit amet, consectetuer adipiscing.",
    fecha: "01/01/2026",
  },
];